// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__28QO2","rootCenter":"LoadMoreObserver_rootCenter__3SQho","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__kcxOm"};